// Recovered compiled webpack factory 95102. Edit this function expression; run npm run build.
(e, t, r) => {
  r.d(t, { A: () => a });
  let a = [
    { label: "Unlimited captures" },
    { label: "No watermark" },
    { label: "Transparent background" },
    { label: "4K, 60FPS exports" },
    { label: "Premium 3D models" },
    { label: "Custom 3D scenes" },
    { label: "Full asset library" },
    { label: "Create and save projects" },
    { label: "AI connection / MCP control", beta: !0 },
  ];
}
